// extracted by mini-css-extract-plugin
export default {"dialog":"DialogAddZone_dialog__YR7Tn","title":"DialogAddZone_title__iMI2C"};